import { Component, Input } from "@angular/core";
import { ExpandNavV2Service } from "@gtmhub/navigation/expand-nav-v2.service";
import { Screens } from "@webapp/navigation/models/shared.models";

@Component({
  selector: "sub-navigation",
  templateUrl: "./sub-navigation.component.html",
  styleUrls: ["./sub-navigation.component.less"],
})
export class SubNavigationComponent {
  @Input()
  public activeScreen: Screens;

  public subSectionTitle: string;
  public isNavExpanded: boolean;

  public constructor(private expandNavV2Service: ExpandNavV2Service) {
    this.expandNavV2Service.subscribe(({ value }) => {
      this.isNavExpanded = value;
    });
    this.isNavExpanded = this.expandNavV2Service.getCurrentValue();
  }

  public onTitleChanged(title: string): void {
    this.subSectionTitle = title;
  }
}
